import { IMPAIRMENT_FILES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/impairment_files_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['impairmentFilesIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
